import { FC, useState, useEffect } from "react";
import { Grid, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import CustomSelect, { IOptions } from "../../FormFields/CustomSelect";
import CustomTextField from '../../FormFields/CustomTextField';
import { useAppDispatch } from "../../../store/hooks";
import { fetchCurrencies } from '../../../store/currencyStore/currencyThunk';

interface BankProps {
  selected: any;
  methods:  any;
  isEdit?: boolean;
}

// Bank component
const Bank: FC<BankProps> = ({selected, methods, isEdit}) => {
  const dispatch = useAppDispatch();
  const [currencyOptions, setCurrencyOptions] = useState<IOptions[]>([]);
  const [bankCurrency, setBankCurrency] = useState('');

  useEffect(() => {
    const setInitialData = () => {
      if(selected) {
        let bank = selected.bankAccounts[0];
        if (isEdit) {
          methods.register("bankId");
          methods.setValue("bankId", bank?._id);
        }
        methods.setValue('accountName', bank?.accountName);
        methods.setValue('accountNumber', bank?.accountNumber);
        methods.setValue('bankName', bank?.bankName);
        methods.setValue('branchName', bank?.branchName);
        methods.setValue('IFSC', bank?.IFSC);
        methods.setValue('currency', bank?.currency);
        setBankCurrency(bank?.currency);
      }
    }

    setInitialData();
    getCurrencies();
    // if(currencyOptions.length > 0) setBankCurrency(currencyOptions[0].label);
  }, [selected, currencyOptions, methods]);

  const getCurrencies = async () => {
    if (!currencyOptions.length) {
      const data: any = await dispatch(fetchCurrencies());

      setCurrencyOptions(data.payload.map((c: any) => {
        return { label: c.code, value: c._id }
      }));
    }
  }

  return (
    <>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Account Name</h5>
        <TextField
          placeholder='Account Name' 
          className='c-text-field' 
          {...methods.register('accountName')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.accountName?.message ?? ""}</p>
        {/* <CustomTextField label="UPI ID" name="upiId" variant="standard" required InputProps={{ readOnly: (selected)? true : false }} /> */}
      </Grid>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Account Number</h5>
       <TextField
          placeholder='Account Number' 
          className='c-text-field' 
          {...methods.register('accountNumber')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.accountNumber?.message ?? ""}</p>
        {/* <CustomTextField label="GPay Number" name="gPayPhone" variant="standard" required InputProps={{ readOnly: (selected)? true : false }} /> */}
      </Grid>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Bank Name</h5>
       <TextField
          placeholder='Bank Name' 
          className='c-text-field' 
          {...methods.register('bankName')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.bankName?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Branch Name</h5>
       <TextField
          placeholder='Branch Name' 
          className='c-text-field' 
          {...methods.register('branchName')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.branchName?.message ?? ""}</p>
      </Grid>
      
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>IFSC</h5>
       <TextField
          placeholder='IFSC' 
          className='c-text-field' 
          {...methods.register('IFSC')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.IFSC?.message ?? ""}</p>
      </Grid>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Currancy</h5>
        {currencyOptions?.length && <Select
          className='c-text-field' 
          {...methods.register("currency")}
          id="currency"
          disableUnderline
          required
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1.5px solid #e9ecf1",
                // width: 255,
                // marginLeft:'-29px !important',
                boxShadow: 'none',
                borderRadius: '5px'
              }
            }
            }}
          style={{width:'100%'}}
          value={bankCurrency ?? ''}
          onChange={(event: SelectChangeEvent<any>) => {
            setBankCurrency(event.target.value);
          }}
          size='small'
          variant='outlined'
          sx={{
            boxShadow: "none",
            // fontSize:12,
            textAlign:'right',
            '& .MuiOutlinedInput-input': {p: 0.5},
            // '& .MuiSelect-select': { p:0 },
            marginBottom:'3px',
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
          }} >
          {currencyOptions && currencyOptions.map((option)=>
            <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
          )}
        </Select>}
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.currency?.message ?? ""}</p>
      </Grid>


      {/* <Grid sx={{ mt: 5 }} item xs={12} md={12} sm={12} lg={12}>
        <Typography variant="body1">{'Bank Details'}</Typography>
        <CustomTextField label="Account Name" name="accountName" required variant="standard" InputProps={{ readOnly: (selected)? true : false }} />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
        <CustomTextField label="Account Number" name="accountNumber" required variant="standard" InputProps={{ readOnly: (selected)? true : false }} />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
        <CustomTextField label="Bank Name" name="bankName" required variant="standard" InputProps={{ readOnly: (selected)? true : false }} />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
        <CustomTextField label="Branch Name" name="branchName" required variant="standard" InputProps={{ readOnly: (selected)? true : false }} />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
        <CustomTextField label="IFSC" name="IFSC" required variant="standard" InputProps={{ readOnly: (selected)? true : false }} />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
        {currencyOptions?.length && <CustomSelect
          name="currency"
          label="Currency *"
          id="currency"
          variant="standard"
          required
          options={currencyOptions}
          value={bankCurrency ?? ''}
          onChange={(event: SelectChangeEvent<any>) => {
            setBankCurrency(event.target.value);
          }} />}
      </Grid> */}
    </>
  );
};

export default Bank;
